import { styled } from '@mui/material/styles'
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'
import { LinkProps as RouterLinkProps } from 'react-router-dom'

export type BreadcrumbLinkProps = Omit<MuiLinkProps, 'component'> & RouterLinkProps

export const BreadcrumbLink = styled(MuiLink, {
    shouldForwardProp: (prop) => prop !== 'sx',
})<BreadcrumbLinkProps>({
    cursor: 'pointer',
    color: 'text.primary',
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
})
